import SearchListContent from './SearchListContent';
import ListRuleBar from '../components/ListRuleBar';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import jsurl from 'jsurl';
import { getSuggestSpuList } from 'api/shop';
import useAreaCookie from '@/hooks/useAreaCookie';

export default function ShopGoods({ spuList }) {
  const [suggestSpuList, setSuggestSpuList] = useState([]);
  const router = useRouter();
  const anchor = router.asPath?.split('#')?.[1] || '';

  const searchParams = useRef<any>({
    sorts: [{ sortField: '', orderBy: 1 }],
    keywords: '',
  });
  const { areaCode } = useAreaCookie();
  const { shopSysNo } = router.query;

  useEffect(() => {
    if (areaCode !== '') {
      getSuggestSpuList(shopSysNo, areaCode).then(({ data }) => {
        setSuggestSpuList(data);
      });
    }
  }, [areaCode, shopSysNo]);

  useEffect(() => {
    // 等待数据加载完毕再获取
    if (anchor === 'hot-sell' && spuList && spuList.datas) {
      const scroll = document.querySelector(`#${anchor}`);
      const rects = scroll.getBoundingClientRect();
      const { top } = rects;
      // 滚动距离=距离顶部的距离+自身商品高度
      window.scrollTo({ top: top + 430, behavior: 'smooth' });
    }
  }, [anchor, spuList]);

  function updateSearch(updateParams) {
    if (updateParams.upstreamSupplierSysNoList) {
      updateParams.agreementSysNoList = [];
      updateParams.contractAgreementSysNoList = [];
    }
    const { query } = router;
    if (!updateParams.pageNo) {
      updateParams.pageNo = 1;
    }
    searchParams.current = { ...searchParams.current, ...updateParams };
    const newQuery = {
      ...query,
      params: jsurl.stringify(searchParams.current),
    };
    const url = {
      pathname: router.pathname,
      query: newQuery,
    };
    const queryStr = Object.entries(newQuery)
      .map((item) => item.join('='))
      .join('&');
    const urlStr = url.pathname + '?' + queryStr;
    router.push(url, urlStr, {
      shallow: true,
    });
  }

  return (
    <>
      <div className="shop-goods-wrap">
        <div className="shop-goods-title">新品上架</div>
        <div className="rule-bar">
          <div className="rule clearfix">
            <ListRuleBar updateSearch={updateSearch} />
          </div>
        </div>
        <div className="goods-grid">
          <SearchListContent shopList={spuList?.datas} />
        </div>

        <div className="shop-goods-title" id="hot-sell">
          热销推荐
        </div>
        <div className="goods-grid">
          <SearchListContent shopList={suggestSpuList} />
        </div>
      </div>
      <style jsx>
        {`
          .rule-bar {
              margin-top: 20px;
              margin-bottom: 20px;
          }
        
          .rule-bar .rule,
          .rule-bar .sort {
            height: 42px;
          }
        
          .shop-goods-wrap .shop-goods-title:before {
            position: absolute;
            content: "";
            width: 2px;
            height: 14px;
            left: 0;
            top: 50%;
            margin-top: -7px;
            background-color: #018DD7;
          }
        
          .shop-goods-wrap .shop-goods-title {
            width: 100%;
            height: 42px;
            background: #f9f9f9;
            border: 1px solid #f1f1f1;
            padding-left: 20px;
            position: relative;
            font-size: 16px;
            line-height: 40px;
            color: #333;
            font-weight: 500;
          }
        
          .preview-item img {
            width: 100%;
            height: 100%;
          }
        
          .preview-bd img {
            width: 100%;
            height: 100%;
          }
          
          .goods-grid:after {
            content: "";
              display: block;
              clear: both;
          }
            `}
      </style>
    </>
  );
}
